<!-- 
    这个实现方式有很多的问题，目前没有好的方案，目前只是用来写布局使用
 -->
<script>
    export let direction = "horizontal";
    export let wrap = false;
    import { classNames } from "../../utils";
    let cls = "sui-space";
</script>

<div
    class={classNames({
        [cls]: cls,
        [`${cls}-wrap`]: wrap,
        [`${cls}-${direction}`]: direction,
    })}
>
    <slot />
</div>

<style lang="less">
    @import "./space.less";
</style>
